/**
 * Featured Articles Pagination - Responsive
 * Handles navigation between groups of article cards with responsive breakpoints
 * Desktop (1024px+): 4 cards, Tablet (768px-1023px): 3 cards, Mobile (<768px): 1 card
 */

(function () {
  function getItemsPerPage() {
    const width = window.innerWidth;
    if (width >= 1025) {
      return 3; // Desktop
    } else if (width >= 769) {
      return 2; // Tablet
    } else {
      return 1; // Mobile
    }
  }

  function initFeaturedArticlesPagination() {
    const section = document.querySelector(".block-featured-articles");
    if (!section) return;

    const cardsContainer = section.querySelector(
      ".block-featured-articles__cards",
    );
    const cards = Array.from(section.querySelectorAll(".resource-card"));
    const paginationContainer = section.querySelector(
      ".block-featured-articles__pagination",
    );
    const prevButton = section.querySelector(".nav-button--prev");
    const nextButton = section.querySelector(".nav-button--next");
    const controlsDiv = section.querySelector(
      ".block-featured-articles__controls",
    );

    if (!cardsContainer || cards.length === 0 || !prevButton || !nextButton)
      return;

    let currentPage = 0;
    let itemsPerPage = getItemsPerPage();

    // Calculate total pages
    function calculateTotalPages() {
      return Math.ceil(cards.length / itemsPerPage);
    }

    // Check if pagination is needed
    function shouldShowControls() {
      return calculateTotalPages() > 1;
    }

    // Create pagination dots
    function renderPaginationDots() {
      paginationContainer.innerHTML = "";
      const newTotalPages = calculateTotalPages();

      for (let i = 0; i < newTotalPages; i++) {
        const dot = document.createElement("button");
        dot.className = `pagination-dot ${i === currentPage ? "pagination-dot--active" : ""}`;
        dot.setAttribute("aria-label", `Go to page ${i + 1}`);
        dot.addEventListener("click", () => goToPage(i));
        paginationContainer.appendChild(dot);
      }
    }

    // Show cards for the current page
    function showPage(pageIndex) {
      const start = pageIndex * itemsPerPage;
      const end = start + itemsPerPage;

      console.log(
        `go from ${currentPage} to ${pageIndex} — items ${start} to ${end}`,
      );

      if (currentPage == 0 && pageIndex == 0) {
        document.querySelector(".block-featured-articles__cards").scrollLeft =
          0;
      } else {
        cards[start].scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "center",
        });
      }

      // if (currentPage < pageIndex) {
      //   // NEXT PAGE - Animate from right to left
      //   cards[end - 1].scrollIntoView({
      //     behavior: "smooth",
      //     inline: "start",
      //     block: "center",
      //   });
      // } else if (currentPage > pageIndex) {
      //   // PREVIOUS PAGE - Animate from left to right
      //   cards[start].scrollIntoView({
      //     behavior: "smooth",
      //     inline: "start",
      //     block: "center",
      //   });
      // } else if (currentPage == 0 && pageIndex == 0) {
      //   // when the page is reloaded, index resets & scroll needs to be corected
      //   cards[0].scrollIntoView({
      //     behavior: "smooth",
      //     inline: "start",
      //     block: "center",
      //   });
      // }

      const newTotalPages = calculateTotalPages();
      // Update button states
      prevButton.disabled = pageIndex === 0;
      nextButton.disabled = pageIndex === newTotalPages - 1;

      // Update pagination data
      cardsContainer.setAttribute("data-current-page", pageIndex);
      currentPage = pageIndex;
    }

    // Navigate to specific page
    function goToPage(pageIndex) {
      const newTotalPages = calculateTotalPages();
      if (pageIndex < 0 || pageIndex >= newTotalPages) return;
      // currentPage = pageIndex;
      showPage(pageIndex);
      renderPaginationDots();
    }

    // Next page handler
    nextButton.addEventListener("click", () => {
      const newTotalPages = calculateTotalPages();
      if (currentPage < newTotalPages - 1) {
        goToPage(currentPage + 1);
      }
    });

    // Previous page handler
    prevButton.addEventListener("click", () => {
      if (currentPage > 0) {
        goToPage(currentPage - 1);
      }
    });

    // Keyboard navigation
    document.addEventListener("keydown", (e) => {
      if (!section.querySelector(":focus-within")) return;

      const newTotalPages = calculateTotalPages();
      if (e.key === "ArrowRight" && currentPage < newTotalPages - 1) {
        goToPage(currentPage + 1);
      } else if (e.key === "ArrowLeft" && currentPage > 0) {
        goToPage(currentPage - 1);
      }
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newItemsPerPage = getItemsPerPage();

        // If items per page changed, recalculate pagination
        if (newItemsPerPage !== itemsPerPage) {
          itemsPerPage = newItemsPerPage;

          // Reset to page 0 if current page is out of range
          if (currentPage >= calculateTotalPages()) {
            currentPage = 0;
          }

          renderPaginationDots();
          showPage(currentPage);
        }

        // Update controls visibility
        if (shouldShowControls()) {
          controlsDiv.style.display = "flex";
        } else {
          controlsDiv.style.display = "none";
        }
      }, 250);
    });

    // Initial render
    if (shouldShowControls()) {
      controlsDiv.style.display = "flex";
      renderPaginationDots();
      showPage(0);
    } else {
      controlsDiv.style.display = "none";
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initFeaturedArticlesPagination,
    );
  } else {
    initFeaturedArticlesPagination();
  }
})();
